import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategorySection from './components/CategorySection';
import LatestArticlesSection from './components/LatestArticlesSection';
import FAQSection from './components/FAQSection';
import DownloadSection from './components/DownloadSection';

export default function Home() {
  const schemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '东升大舞台App入口 - 官方下载与登录指南',
      description: '东升大舞台App入口官方直达，提供最新版本下载、快速登录注册教程及常见问题解答。安卓iOS均可一键找到正规入口。',
      url: 'https://dongshengdawutai.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '东升大舞台',
        url: 'https://dongshengdawutai.com/',
      },
    },
  ];

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="东升大舞台App入口 - 官方下载与登录指南 | 安卓iOS安全下载"
        description="东升大舞台App入口官方直达，提供最新版本下载、快速登录注册教程及常见问题解答。无论安卓还是iOS用户，均可一键找到东升大舞台App正规入口，安全稳定，畅享精彩演艺内容与互动体验。"
        keywords="东升大舞台app入口,东升大舞台下载,东升大舞台登录,东升大舞台官方入口,东升大舞台安卓下载,东升大舞台iOS下载,东升大舞台注册"
        canonicalUrl="https://dongshengdawutai.com/"
        schemaData={schemaData}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategorySection />
        <LatestArticlesSection />
        <FAQSection />
        <DownloadSection />
      </main>
      <Footer />
    </>
  );
}